export default {
  isProfessionalRedeConexa: ({ userServiceProfile }) => {
    return userServiceProfile?.redeConexa || false;
  },
};
